export default "__VITE_ASSET__BR2E200V__"